import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_USERS_FOR_SUBSCRIPTION_FORM_SAGA } from "../sagaTypes";
import { loaderAction, addSubscriptionFormAction, setBookingUsersFormAction, dropdownAction, familyFormAction, filterUserAction,
    notificationsFormAction, oneTimeWorkoutFormAction, storeFormAction, setServicesFormAction,
    subscriptionFormAction, usersAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/users_for_subscription_form`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetUsersForSubscription(args) {
    const user = yield select(state => state.user);
    const addSubscriptionForm = yield select(state => state.addSubscriptionForm);
    const subscriptionForm = yield select(state => state.subscriptionForm);
    const notifications_form = yield select(state => state.notifications_form);
    const oneTimeWorkoutForm = yield select(state => state.oneTimeWorkoutForm);
    const filterUser = yield select(state => state.filterUser);
    const booking_users_form = yield select(state => state.booking_users_form);
    const familyForm = yield select(state => state.familyForm);
    const storeForm = yield select(state => state.storeForm);
    const services_form = yield select(state => state.services_form);

    yield put(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('text', args.data.text);
        formData.append('children', args.data.children || '0');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {

            if (args.data.type === 'edit') {
                yield put(subscriptionFormAction({
                    ...subscriptionForm,
                    users: response.users
                }));
            }
            else if (args.data.type === 'add') {
                yield put(addSubscriptionFormAction({
                    ...addSubscriptionForm,
                    users: response.users
                }));
            }
            else if (args.data.type === 'notification') {
                yield put(notificationsFormAction({
                    ...notifications_form,
                    users: response.users
                }));
            }
            else if (args.data.type === 'specific_user') {
                yield put(usersAction(response.users));
                yield put(dropdownAction('users'));
            }
            else if (args.data.type === 'one_time') {
                yield put(oneTimeWorkoutFormAction({
                    ...oneTimeWorkoutForm,
                    users: response.users
                }));
            }
            else if (args.data.type === 'filter') {
                yield put(filterUserAction({
                    ...filterUser,
                    users: response.users
                }));

                if (response.users.length) {
                    yield put(dropdownAction('filter_user'));
                }
                else {
                    yield put(dropdownAction(null));
                }
            }
            else if (args.data.type === 'booking_users_form') {
                yield put(setBookingUsersFormAction({
                    ...booking_users_form,
                    users: response.users
                }));
            }
            else if (args.data.type === 'familyForm') {
                yield put(familyFormAction({
                    ...familyForm,
                    users: response.users
                }));
            }
            else if (args.data.type === 'storeForm') {
                yield put(storeFormAction({
                    ...storeForm,
                    users: response.users
                }));
            }
            else if (args.data.type === 'services_form') {
                yield put(setServicesFormAction({
                    ...services_form,
                    users: response.users
                }));
            }
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetUsersForSubscription() {
    yield takeLatest(GET_USERS_FOR_SUBSCRIPTION_FORM_SAGA, workerGetUsersForSubscription);
}